/** @format */

/* istanbul ignore file */

export const PLA_PLACEHOLDER_HIDDEN_CLASS = 'hmf-display-none pla-placeholder-replacement';
export const PLA_PLACEHOLDER_VISIBLE_CLASS = 'pla-placeholder-replacement';
